import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

export interface VideoData {
  id: string;
  title: string;
  description: string;
  url: string;
}

@Component({
    selector: 'app-video-dialog2',
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.css'],
    imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose]
})
export class VideoDialogComponent implements OnInit {

  videoList: VideoData[] = [
    {
      id: 'productive',
      title: 'Meetings More Productive',
      description: 'Productivity up, tension down...members relaxed...',
      url: 'assets/video/testimonials/Needtounderstand.mp4',
    },
    {
      id: 'itworks',
      title: 'Have seen it work',
      description: 'It is for a group',
      url: 'assets/video/testimonials/Ihaveseenitwork.mp4',
    },
    {
      id: 'needit',
      title: 'You need this class',
      description: 'To participate effectively, you need this class',
      url: 'assets/video/testimonials/Ifyouareaparticipantyouneedtotakethisclass.mp4',
    }
    // Add 3 more...
  ];

   selectedVideo!: VideoData;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { videoIndex: number }) { }

  ngOnInit(): void {

    const index = this.data.videoIndex;
    // ✅ Safely assign video if index is valid
    if (index >= 0 && index < this.videoList.length) {
      this.selectedVideo = this.videoList[index];
    } else {
      console.warn('Invalid video index');
    }

  }

}
